import React from "react";
import { Link } from "react-router-dom";
import { Wand2, Search, Sparkles, ChevronRight, Construction, Zap } from "lucide-react";

const TOOLS = [
  {
    id: "keyword-analyzer",
    to: "/ai-araclar/anahtar-kelime",
    title: "Anahtar Kelime Analizi",
    desc: "Google Keyword Planner veya Arama Terimleri CSV'sini yükleyin — AI pozitif/negatif anahtar kelime listenizi gruplandırılmış şekilde üretsin.",
    icon: Search,
    status: "ready",
    accent: "#4F46E5",
    badge: "AI Destekli",
  },
  {
    id: "ad-copy",
    to: "/ai-araclar/reklam-metni",
    title: "Reklam Metni Üretici",
    desc: "Anahtar kelimelere, marka tonuna ve ek talimatlarınıza göre Google Ads RSA için 15 başlık + 4 açıklama üretir. Tek tek revize edebilirsiniz.",
    icon: Sparkles,
    status: "ready",
    accent: "#D97706",
    badge: "AI Destekli",
  },
  {
    id: "indexboost",
    to: "/ai-araclar/indexboost",
    title: "IndexBoost — SEO Hızlandırıcı",
    desc: "Yeni veya unutulmuş sayfaları arama motorlarına hemen tanıtın: IndexNow (Bing/Yandex) toplu ping, Search Console sitemap submit, AI iç-bağlantı önerileri ve sosyal medya patlaması.",
    icon: Zap,
    status: "ready",
    accent: "#0EA5E9",
    badge: "Yeni",
  },
];

const SOON = [
  { title: "SEO İçerik Briefi", desc: "Konu + hedef kitle → kapsamlı içerik planı" },
  { title: "Rakip Analizi", desc: "URL listesi → konum, anahtar kelime, açık fırsatlar" },
];

export default function AiToolsIndexPage() {
  return (
    <div className="space-y-6" data-testid="ai-tools-index">
      <div className="flex items-start gap-3">
        <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#4F46E5] to-[#7C3AED] flex items-center justify-center shrink-0">
          <Wand2 size={20} className="text-white"/>
        </div>
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">AI Araçlar</h1>
          <p className="text-sm text-[#64748B] mt-1 max-w-2xl">Zaman alan dijital pazarlama ve SEO işlerini hızlandıran yapay zeka destekli araçlar. Yeni araçlar eklenmeye devam edecek.</p>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {TOOLS.map(t => (
          <Link key={t.id} to={t.to} data-testid={`ai-tool-${t.id}`} className="ky-card p-5 hover:shadow-md transition-all hover:-translate-y-0.5 group">
            <div className="flex items-start justify-between mb-3">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: t.accent + "15" }}>
                <t.icon size={18} style={{ color: t.accent }}/>
              </div>
              <span className="ky-badge ky-badge-success">{t.badge}</span>
            </div>
            <div className="font-semibold text-base mb-1">{t.title}</div>
            <p className="text-xs text-[#64748B] leading-relaxed">{t.desc}</p>
            <div className="flex items-center gap-1 mt-3 text-xs font-medium text-[#4F46E5] group-hover:gap-2 transition-all">
              Aracı Aç <ChevronRight size={14}/>
            </div>
          </Link>
        ))}

        {SOON.map((s, i) => (
          <div key={i} className="ky-card p-5 opacity-60 border-dashed">
            <div className="flex items-start justify-between mb-3">
              <div className="w-10 h-10 rounded-lg bg-[#F4F4F5] flex items-center justify-center">
                <Construction size={18} className="text-[#94A3B8]"/>
              </div>
              <span className="ky-badge ky-badge-neutral">Yakında</span>
            </div>
            <div className="font-semibold text-base mb-1">{s.title}</div>
            <p className="text-xs text-[#64748B] leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>

      <div className="ky-card p-5 bg-gradient-to-br from-[#EEF2FF] to-[#F5F3FF] border-[#C7D2FE]">
        <div className="flex items-start gap-3">
          <Sparkles size={18} className="text-[#4F46E5] mt-0.5 shrink-0"/>
          <div>
            <div className="font-semibold text-sm text-[#0F172A]">İhtiyacınız olan bir araç mı var?</div>
            <p className="text-xs text-[#64748B] mt-1">Tekrarlayan iş süreçlerinizi bize bildirin, yapay zekayla otomatikleştirelim. Mevcut akışı incelyip uygun aracı geliştiririz.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
